export const version = "abi/5.8.0";
//# sourceMappingURL=_version.js.map